import getRelativeUrl from "helpers/getRelativeUrl";

export default (text: string | undefined): { __html: string } | undefined => {
    let result = undefined;

    if (text) {
        const parsedText = getRelativeUrl(text);

        result = {
            __html: parsedText
        };
    }

    return result;
};
